import { Component, EventEmitter, Input, OnInit, ViewChild, signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CreateProfessionalDevelopmentRecordCommand,
  LeaProfessionalDevelopmentClient,
  SimpleSelectOptionDto,
} from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/utilities/validator-utilities';
import { finalize } from 'rxjs';

@Component({
  selector: 'cert-award-pd-modal',
  standalone: false,
  templateUrl: './award-pd-modal.component.html',
})
export class AwardProfessionalDevelopmentModalComponent implements OnInit {
  @Input() selectionCount = 0;
  @Input() personIds: number[] = [];
  @Input() professionalDevelopmentTypeOptions: SimpleSelectOptionDto[] = [];
  @Input() leaCodeId!: number;
  @ViewChild('awardForm') form!: NgForm;
  submitting = signal(false);
  createProfessionalDevelopmentRecordCommand!: CreateProfessionalDevelopmentRecordCommand;

  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly professionalDevelopmentClient: LeaProfessionalDevelopmentClient,
  ) {}

  ngOnInit() {
    this.createProfessionalDevelopmentRecordCommand = {
      personIds: this.personIds,
      description: undefined,
      hours: undefined,
      completionDate: undefined,
      professionalDevelopmentTypeCodeId:
        this.professionalDevelopmentTypeOptions.length === 1
          ? this.professionalDevelopmentTypeOptions[0].id
          : undefined,
      leaCodeId: this.leaCodeId,
    };
  }

  confirm() {
    this.submitting.set(true);
    this.professionalDevelopmentClient
      .createProfessionalDevelopmentRecord(this.createProfessionalDevelopmentRecordCommand)
      .pipe(
        catchValidationErrors(this.form, this.errorEmitter),
        finalize(() => this.submitting.set(false)),
      )
      .subscribe({
        next: () => this.activeModal.close(true),
      });
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
